import { useState } from "react";

const AddLabelModal = ({ show, setShow, products, setProducts }) => {
  const [selectedProductId, setSelectedProductId] = useState("");
  const [qty, setQty] = useState("");
  const [extractNo, setExtractNo] = useState("");

  const saveLabel = () => {
    if (!selectedProductId || !qty || !extractNo) {
      alert("All fields are required");
      return;
    }

    const selected = products.find(
      (p) => p.id === Number(selectedProductId)
    );

    const newItem = {
      ...selected,
      product_qty: qty,
      label_extract_no: extractNo,
    };

    setProducts((prev) => [...prev, newItem]);

    setSelectedProductId("");
    setQty("");
    setExtractNo("");

    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Add Label</h5>
            <button className="btn-close" onClick={() => setShow(false)}></button>
          </div>

          <div className="modal-body">
            <label>Select Product</label>
            <select
              className="form-control mb-2"
              value={selectedProductId}
              onChange={(e) => setSelectedProductId(e.target.value)}
            >
              <option value="">Select...</option>
              {products.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.product_name}
                </option>
              ))}
            </select>

            <label>Quantity</label>
            <input
              className="form-control mb-2"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
            />

            <label>Label Extract No</label>
            <input
              className="form-control mb-2"
              value={extractNo}
              onChange={(e) => setExtractNo(e.target.value)}
            />

            <label>Label Name</label>
            <input
              className="form-control mb-2"
              value={extractNo}
              onChange={(e) => setExtractNo(e.target.value)}
            />
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={() => setShow(false)}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={saveLabel}>
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AddLabelModal;
